import { render, staticRenderFns } from "./CancelledApprovals.vue?vue&type=template&id=8f4c5dc0"
import script from "./CancelledApprovals.vue?vue&type=script&lang=js"
export * from "./CancelledApprovals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports